import React from 'react';
import PropTypes from 'prop-types';

const ProductImageGallery = ({ images, selectedImage, onImageSelect }) => {
  const mainImage = images?.[selectedImage] || images?.[0];

  return (
    <div className="space-y-4">
      {/* Main Image */}
      <div className="aspect-square bg-gray-100 rounded-lg overflow-hidden">
        <img
          src={mainImage?.url || '/placeholder-product.jpg'}
          alt={mainImage?.alt || 'Product image'}
          className="w-full h-full object-cover"
          onError={(e) => {
            e.target.src = '/placeholder-product.jpg';
          }}
        />
      </div>

      {/* Thumbnail Gallery */}
      {images?.length > 1 && (
        <div className="grid grid-cols-4 gap-2">
          {images.map((image, index) => (
            <button
              key={image._id || index}
              onClick={() => onImageSelect(index)}
              className={`aspect-square rounded-md overflow-hidden border-2 ${
                selectedImage === index
                  ? 'border-pinkAccent'
                  : 'border-transparent'
              }`}
              aria-label={`View image ${index + 1}`}
            >
              <img
                src={image.url || '/placeholder-product.jpg'}
                alt={image.alt || `Thumbnail ${index + 1}`}
                className="w-full h-full object-cover"
                onError={(e) => {
                  e.target.src = '/placeholder-product.jpg';
                }}
              />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

ProductImageGallery.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string,
      alt: PropTypes.string,
      _id: PropTypes.string
    })
  ),
  selectedImage: PropTypes.number,
  onImageSelect: PropTypes.func
};

export default ProductImageGallery;